/* eslint-disable react/display-name */
import React from 'react'

import './code-blocks-wrapper.css'

export default ({ children }: any) => {
  return <div className="codeBlocks-wrapper">{children}</div>
}
